import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    startTime?: ?string;
}

export class TimesheetEntryStartTime extends React.PureComponent<Props> {
    render() {
        const { startTime } = this.props;
        if (!startTime) return null;
        return moment(startTime, 'HH:mm:ss').format('h:mm a');
    }
}

const mapStateToProps = createStructuredSelector({
    startTime: makeSelectTimesheetEntryValue('startTime')
});

export default connect(mapStateToProps)(TimesheetEntryStartTime);
